import React from "react";
import YoutubeVideo from "../../youtubeVideo";

function StoryblokYoutubeVideoAdapter({ link }) {
  return <YoutubeVideo link={link} />;
}

export default StoryblokYoutubeVideoAdapter;
